import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Card, CardHeader, CardBody, CardFooter, CardText, Button } from 'reactstrap'

export default function LoginExpired() {
  console.log('LoginExpired rendered')

  const [goToLogin, setGoToLogin] = useState(false)

  if (goToLogin) {
    return <Navigate to="/login" />
  }
  return (
    <Card style={{ maxWidth: '500px', margin: '0 auto' }} >
      <CardHeader tag="h4">Login Expired</CardHeader>
      <CardBody>
        <CardText>Your last successful authorization has expired.  Please sign in again.</CardText>
      </CardBody>
      <CardFooter style={{ backgroundColor: 'white', textAlign: 'center' }} >
        <Button color="primary" style={{ fontSize: '1.25rem' }} onClick={() => setGoToLogin(true)}>Return to Sign In</Button>
      </CardFooter>
    </Card>
  )
}
